<template>
  <el-alert
    v-if="visible"
    class="referral-bind-banner"
    type="warning"
    :closable="true"
    show-icon
    @close="dismiss"
  >
    <template #title>
      您尚未绑定礼券
      <span v-if="daysRemaining != null">（剩余 {{ daysRemaining }} 天）</span>
    </template>
    绑定后可获得相应礼遇。邀请码用于注册，礼券需在注册后单独绑定。
    <el-button type="primary" size="small" link @click="goBind">立即绑定</el-button>
  </el-alert>
</template>

<script>
import { isLoggedIn } from '@/utils/loginFlow'
import { fetchReferralBindStatus } from '@/utils/referralCoupon'

const DISMISS_KEY = 'referral_bind_banner_dismissed_until'

export default {
  name: 'ReferralBindBanner',
  data() {
    return {
      visible: false,
      daysRemaining: null
    }
  },
  watch: {
    '$route.path'() {
      this.check()
    }
  },
  mounted() {
    this.check()
  },
  methods: {
    async check() {
      const path = this.$route.path
      if (!isLoggedIn() || path.startsWith('/admin') || path === '/referral/bind-coupon' || path === '/login' || path === '/register') {
        this.visible = false
        return
      }
      const dismissed = Number(sessionStorage.getItem(DISMISS_KEY) || 0)
      if (dismissed > Date.now()) {
        this.visible = false
        return
      }
      try {
        const st = await fetchReferralBindStatus()
        this.daysRemaining = st.daysRemaining != null ? Number(st.daysRemaining) : null
        this.visible = !st.hasBinding && st.canBind
      } catch {
        this.visible = false
      }
    },
    dismiss() {
      sessionStorage.setItem(DISMISS_KEY, String(Date.now() + 3600000))
      this.visible = false
    },
    goBind() {
      this.$router.push('/referral/bind-coupon')
    }
  }
}
</script>

<style scoped>
.referral-bind-banner {
  margin: 0;
  border-radius: 0;
}
</style>
